import type {HTMLAttributes} from 'react';
import {useApplication} from '../../contexts';
import {usePlayerState} from '../../hooks';
import {formatDuration} from '../../utils';

interface TimestampProps extends HTMLAttributes<HTMLInputElement> {
  frame: number;
  title: string;
}

export function Timestamp({
  frame,
  title,
  ...rest
}: TimestampProps) {
  const {player} = useApplication();
  const {speed} = usePlayerState();

  let precision = 0;
  let padding = player.status.fps.toString().length;
  if (speed % 1 !== 0) {
    precision = 2;
    padding += 3;
  }

  return (
    <code {...rest}>
      <span title={`${title} [HH:MM:SS:FF]`}>
        {formatDuration(player.status.framesToSeconds(frame))}:
        {(frame % player.status.fps).toFixed(precision).padStart(padding, '0')}
      </span>
    </code>
  );
}
